import { atom } from 'recoil';

export const shops = atom({
  key: 'shops',
  default: undefined,
});
